// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--UUkrS","tag":"_93444fe79c--tag--eEtWc"};